import Vue from 'vue'
import Component from './abModal.vue'

const ModalConstructor = Vue.extend(Component)

const instances = []
let seed = 1
const removeInstance = (instance) => {
  if (!instance) return
  const index = instances.findIndex(ins => instance.id === ins.id)

  instances.splice(index, 1)
}

const abModal = (options) => {
  if (Vue.prototype.$isServer) return
  return new Promise((resolve, reject) => {
    const { ...rest } = options
    const instance = new ModalConstructor({
      propsData: {
        width: 360,
        oneCenter: true,
        ...rest
      }
    })

    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.visible = true

    instance.id = `ab_modal_${seed++}`

    instances.push(instance)

    // 动画执行完关闭
    instance.vm.$on('closed', () => {
      removeInstance(instance)
      document.body.removeChild(instance.vm.$el)
      instance.vm.$destroy()
    })
    // // 点击关闭后直接隐藏
    instance.vm.$on('close', () => {
      instance.visible = false
      reject(0)
    })
    instance.vm.$on('confirm', () => {
      instance.visible = false
      resolve(1)
    })
    return instance.vm
  })
}

export default abModal
